import './index.scss'
import { initApp, setActiveNav } from 'app/js/app'

$(() => {
      initApp()
      initialize()
})

function drawMap(map, point, marker, searchInfoWindow) {
      map.centerAndZoom(point, 14)
      map.addOverlay(marker)
      map.enableScrollWheelZoom()
      marker.setAnimation(BMAP_ANIMATION_BOUNCE)
      setTimeout(() => { //2秒后放大到14级
          map.addOverlay(marker)
          marker.setAnimation()
          // searchInfoWindow.open(marker);
          map.setZoom(16)
      }, 2000)
}

function initialize() {
      var map = new BMap.Map("map") // 创建地图实例
      var point = new BMap.Point(116.503926, 39.980685) // 创建点坐标
      var marker = new BMap.Marker(point) // 创建标记
      // var img = '<img src="../img/baidu.jpg" alt="" style="float:right;zoom:1;overflow:hidden;width:100px;height:100px;margin-left:3px;"/>'
      var content = '<div style="margin:0;line-height:20px;">' +
          '地址：北京市朝阳区酒仙桥路14号院<br/>电子城研发中心A5号楼725室' +
          '</div>'
      var searchInfoWindow = null
      drawMap(map, point, marker, searchInfoWindow)
      marker.addEventListener("click", function (e) {
                searchInfoWindow.open(marker);
                marker.setAnimation()
            })
      map.addOverlay(marker)

}



// WEBPACK FOOTER //
// ./src/us/index.js